<template>
  <!--<div class="footer">-->
    <!--<div class="links">-->
      <!--<a href="http://www.jeecg.com" target="_blank">嘀盟CRM首页</a>-->
    <!--</div>-->
    <!--<div class="copyright">-->
      <!--Copyright-->
      <!--<a-icon type="copyright"/>-->
      <!--2021 <span>嘀盟CRM 出品</span>-->
    <!--</div>-->
  <!--</div>-->
</template>

<script>
  export default {
    name: "LayoutFooter"
  }
</script>

<style lang="less" scoped>
  .footer {
    padding: 0 16px;
    margin: 6px 0 6px;
    text-align: center;

    .links {
      margin-bottom: 8px;

      a {
        color: rgba(0, 0, 0, .45);

        &:hover {
          color: rgba(0, 0, 0, .65);
        }

        &:not(:last-child) {
          margin-right: 40px;
        }
      }
    }
    .copyright {
      color: rgba(0, 0, 0, .45);
      font-size: 14px;
    }
  }
</style>